/* 
acquired by running:
query {
  footer: contentfulFooter(brand: { name: { eq: "TopCV.co.uk" } }) {
    ...Footer
  }
}
*/

export const footer = {
  footer: {
    name: 'TopCV.co.uk Footer',
    contentful_id: '74NRkz6oxX33GNULl6JYcX',
    badge: {
      description: 'Norton powered by digicert ',
      file: {
        url: '//images.ctfassets.net/7thvzrs93dvf/1dx4z5Ue8HwEgZD7sdJepS/8b2d10e5c89a2e003c43193e2539e877/download.png',
      },
    },
    phoneText: null,
    creditCards: null,
    bottomNavigation: [
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: '6kQQdDnlL0BkMSk7KKbZon',
        title: 'Legal',
        category: null,
        links: [
          {
            contentful_id: '3GNufuOHooLDI0g2pnjJRq',
            __typename: 'ContentfulInternalLink',
            text: 'Terms and Conditions',
            slug: 'terms?dt={{discountToken}}',
            icon: null,
            codeClasses: null,
            mixpanelTracking: null,
          },
          {
            contentful_id: '7mwEJ2uj5O23vFkp4gVJgY',
            __typename: 'ContentfulInternalLink',
            text: 'Privacy Policy',
            slug: 'privacy?dt={{discountToken}}',
            icon: null,
            codeClasses: null,
            mixpanelTracking: null,
          },
          {
            contentful_id: '75J6mICNMqYuMOsRF5nLS9',
            __typename: 'ContentfulInternalLink',
            text: 'Cookie Policy',
            slug: 'cookies?dt={{discountToken}}',
            icon: null,
            codeClasses: null,
            mixpanelTracking: null,
          },
          {
            contentful_id: '3ceAkkoR2dgk9CaU0sDFhm',
            __typename: 'ContentfulInternalLink',
            text: 'Do Not Sell',
            slug: 'do-not-sell?dt={{discountToken}}',
            icon: null,
            codeClasses: null,
            mixpanelTracking: null,
          },
        ],
        variant: null,
        link: null,
      },
    ],
    navigation: [
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: 'Rx0LwVmVPrkvV7Dvpj2e6',
        title: 'Products',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '2dndhA2wKPwIrXP5HNsmSs',
            text: 'CV Writing Packages',
            url: '/cv-writing?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'cv_writing_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '7zYXDHy6zlKn8PvYGRnGVz',
            text: 'LinkedIn Profile Writers',
            url: '/linkedin-profile-services?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'linkedin_services_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '32Q5yDHWtYQA6gQEtPHUsw',
            text: 'Free CV Critique',
            url: '/cv-review?dt=discountToken',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'cv_review_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
        ],
        variant: null,
        link: null,
      },
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: '7wRzjAyqcPpa3m0OFISKMp',
        title: 'Learn More',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '6i8kQzHzJWOP1ocz8afxq1',
            text: 'Frequently Asked Questions',
            url: '/faq?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'faqs_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '62tkg7twhfIc5E2nJ3NGtZ',
            text: 'Customer Success Stories',
            url: '/success-stories?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'success_stories_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '43gbsZJTNrhU84UGno9yM8',
            text: 'Career Advice Blog',
            url: '/career-advice?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: 'Same tab',
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'career_advice_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
        ],
        variant: null,
        link: null,
      },
      {
        __typename: 'ContentfulNavigationGroup',
        contentful_id: '77PunUAU5PcsAtBksuUohB',
        title: 'Company',
        category: null,
        links: [
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '5IyPNxERefNFUUe1JHr24t',
            text: 'About',
            url: '/about?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'about_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '7zjMQePvhVajoVfAJZhDRx',
            text: 'Contact Us',
            url: '/contact?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'contact_us_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '5B8fyA2Bt4t5WyPSTBaK0m',
            text: 'Press Room',
            url: '/press?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'press_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
          {
            __typename: 'ContentfulExternalLink',
            contentful_id: '12ti43R1B7boR86WZ6Zj6O',
            text: 'Partnerships',
            url: '/partnerships?dt={{discountToken}}',
            icon: null,
            openTheLinkIn: null,
            stagingUrl: null,
            devUrl: null,
            codeClasses: null,
            mixpanelTracking: {
              eventName: 'partnerships_click',
              trackingData: {
                internal: {
                  content: '{"event_type":"footer_event"}',
                },
              },
              trackOn: null,
            },
          },
        ],
        variant: null,
        link: null,
      },
    ],
    showNewsletterForm: null,
  },
}
